var map = {
	"./BNB.svg": "d60d",
	"./GNO.svg": "de8d",
	"./SALT.svg": "97d5",
	"./ae.svg": "5fb0",
	"./aion.svg": "5626",
	"./appc.svg": "8392",
	"./ast.svg": "ea83",
	"./bat.svg": "d769",
	"./bch.svg": "ec07",
	"./bnt.svg": "dde4",
	"./brd.svg": "ac0b",
	"./btc.svg": "a9b0",
	"./btg.svg": "2c72",
	"./cdt.svg": "948e",
	"./cvc.svg": "75b6",
	"./dash.svg": "818f",
	"./data.svg": "d8bc",
	"./dent.svg": "8e01",
	"./elf.svg": "bb09",
	"./enj.svg": "769c",
	"./eos.svg": "c22f",
	"./eth.svg": "0c4c",
	"./eur.svg": "1dc6",
	"./fun.svg": "6641",
	"./gbp.svg": "2f52",
	"./gnt.svg": "e3a7",
	"./gto.svg": "112f",
	"./hot.svg": "bf9d",
	"./key.svg": "97a4",
	"./knc.svg": "6b09",
	"./link.svg": "998b",
	"./loom.svg": "cc14",
	"./lrc.svg": "9a9d",
	"./ltc.svg": "5622",
	"./mft.svg": "49a4",
	"./mith.svg": "949f",
	"./mtl.svg": "faa0",
	"./nas.svg": "5fb8",
	"./npxs.svg": "d9a1",
	"./omg.svg": "6912",
	"./pax.svg": "17dc",
	"./poly.svg": "b429",
	"./powr.svg": "bb75",
	"./ppt.svg": "6212",
	"./rdn.svg": "a381",
	"./rep.svg": "6cfe",
	"./snt.svg": "fa86",
	"./sol.svg": "1d4a",
	"./storj.svg": "3d6a",
	"./storm.svg": "f12f",
	"./tnt.svg": "ba46",
	"./trx.svg": "041a",
	"./tusd.svg": "5e75",
	"./usd.svg": "cc2c",
	"./usdc.svg": "e0eb",
	"./usdt.svg": "d48b",
	"./wtc.svg": "3195",
	"./xlm.svg": "a2ae",
	"./xrp.svg": "7ce1",
	"./zec.svg": "9fd1",
	"./zil.svg": "aa09",
	"./zrx.svg": "253c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "536b";